import { useEffect } from 'react';
const PIXEL_ID = '1327135532923755';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}

/**
 * Loads Meta Pixel after the app is visible. A blocked third-party script is
 * non-fatal, so privacy extensions can never interrupt the checkout page.
 */
export function MetaPixel() {
  useEffect(() => {
    try {
      if (window.fbq?.loaded || document.getElementById('meta-pixel-script')) return;
      const queuedPixel = ((...args: unknown[]) => {
        queuedPixel.queue?.push(args);
      }) as PixelFunction;
      queuedPixel.queue = [];
      queuedPixel.push = (...args: unknown[]) => queuedPixel.queue?.push(args);
      queuedPixel.loaded = false;
      queuedPixel.version = '2.0';
      window.fbq = queuedPixel;
      window._fbq = queuedPixel;
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onerror = () => {
        // Trackers may be blocked by browsers or extensions. Keep the app intact.
        script.remove();
      };
      document.head.appendChild(script);
    } catch {
      // Analytics must never prevent the sales page from rendering.
    }
  }, []);
  return null;
}

/** Fire a checkout-intent event only when the pixel queue is available. */
export function trackInitiateCheckout() {
  try {
    window.fbq?.('track', 'InitiateCheckout');
  } catch {
    // Analytics failures must not interrupt checkout navigation.
  }
}